import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Container, Title, Description } from './styles'

export const BNutritionBanner = ({ texts }) => {
  const { title, description } = texts

  return (
    <Wrapper>
      <Container>
        <Title
          weight={'medium'}
          size={['65/70', '30/40', '30/40']}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Description
          size={['22/30', '22/30', '16/25']}
          dangerouslySetInnerHTML={{ __html: description }}
        />

      </Container>
    </Wrapper>
  )
}

BNutritionBanner.propTypes = {
  texts: PropTypes.object.isRequired,
}
